module.exports = "<app-notices></app-notices>\r\n<app-loading></app-loading>\r\n<router-outlet></router-outlet>\r\n<toaster-container [toasterconfig]=\"toasterconfig\"></toaster-container>\r\n<a href=\"javascript:void(0);\" class=\"back-to-top\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Back To Top\">\r\n  <span class=\"back-to-top-text\">\r\n    <i class=\"glyphicon glyphicon-chevron-up\"></i>\r\n  </span>\r\n</a>\r\n<div *ngIf=\"!isprod\" class=\"dev-flag\">Dev</div>\r\n"


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main